import React from "react";
import Button from "@material-ui/core/Button";
import MuiDialog from "@material-ui/core/Dialog";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import SearchIcon from "@material-ui/icons/Search";
import Box from "@material-ui/core/Box";
import Collapse from "@material-ui/core/Collapse";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import MuiTableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import CancelRoundedIcon from "@material-ui/icons/CancelRounded";
import { history } from "../../_redux/_store/history";
import {
  Typography,
  TextField,
  InputAdornment,
  IconButton,
  makeStyles,
  Grid,
  Chip
} from "@material-ui/core";
import { withStyles } from "@material-ui/styles";
import { useState } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Autocomplete from "@material-ui/lab/Autocomplete";
import {
  fetchSignals,
  fetchAnomalyRule,
  setTypeFilters,
} from "../../_redux/_actions/anomalyRuleActions";
import SkeletonTableList from "../skeleton/SkeletonTableList.jsx";
import SkeletonPaper from "../skeleton/SkeletonPaper.jsx";
import FooterPagination from "../_footerpagination/FooterPagination";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import {
  fetchAnomalyHMI,
  fetchAnomalyNode,
  fetchAnomalyFunction,
} from "../../_redux/_actions/scopedAnomalyRuleActions";
import { persistAnomalyRuleFilter } from "../../_redux/_actions/detailsPersistActions";
import CreateAnomalyRule from "../anomalyRule/CreateAnomalyRule.jsx"
import axios from "axios";
import queryString from "query-string";

const useStyles = makeStyles((theme) => ({
  alignBottom: {
    alignSelf: "flex-end",
  },
  machineTypeFilter: {
    padding: "10px",
    width: "300px",
  },
  dialogAction: {
    justifyContent: "flex-start",
  },
  label: {
    fontWeight: "bold",
    marginBottom:'15px'
  },
  chip: {
    alignSelf: "flex-end",
    backgroundColor: "white",
    margin: " 5px",
  },
  tableHead: {
    color: "white",
  },
  requiredField:{
    '& .MuiFormLabel-asterisk':{
      color: '#CE3800'
    }
  },
  signalHeading: {
    fontSize: "20px",
    fontWeight: "bold",
    marginBottom: "10px",
  },
  signalInfo: {
    marginTop: "10px",
  },
  signalTableHead: {
    fontSize: "20px",
  },
  signalcell: {
    borderBottom: "none",
  },
  binIcon: {
    marginBottom: "-5px",
    cursor: "pointer",
  },
  aligningDiv:{
    marginTop:'20px'
  },
  cancelIconStyle:{
    margin:"auto",
    color:'white',
    display:'flex',
    justifyContent:'center',
    alignItems:'center',
    cursor:'pointer'
  }
}));

const Dialog = withStyles(() => ({
  paper: {
    backgroundColor: "#F6F6F6",
    padding: "unset",
  },
  paperScrollPaper: {
    margin:'unset',
    width: '80%',
    maxWidth:'unset',
    maxHeight:'unset'
  }
}))(MuiDialog);

const DialogTitle = withStyles(() => ({
  root: {
    padding: "16px 0px",
  },
}))(MuiDialogTitle);

const DialogContent = withStyles(() => ({
  root: {
    width: "100%",
    backgroundColor: "white",
    alignSelf: "center",
    padding: "0px",
  },
}))(MuiDialogContent);

const TableHead = withStyles(() => ({
  root: {
    backgroundColor: "#666666",
    color: "white",
  },
}))(MuiTableHead);

const Row = (props) => {
  const {
    rule,
    handleCloseDialog,
    handleUpdate,
    selectedEntities,
    anomalyRuleComponent,
    handleDelete,
    moduleFrom
  } = props;
  const [open, setOpen] = useState(true);
  const classes = useStyles();
  return (
    <React.Fragment>
      <TableRow hover>
        <TableCell>
          <IconButton
            aria-label='expand row'
            size='small'
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowDownIcon /> : <KeyboardArrowRightIcon />}
          </IconButton>
        </TableCell>
        <TableCell>{rule.id}</TableCell>
        <TableCell scope='row' style={{ width: "120px" }}>
          {rule.anomalyType.id}
          <Collapse in={open} timeout='auto' unmountOnExit>
            <Box style={{ width: "600px" }}>
              <Grid container direction='column' className={classes.signalInfo}>
                <Grid item>
                  <Typography className={classes.signalHeading}>
                    Signals
                  </Typography>
                </Grid>
                <Grid item>
                  <Table
                    aria-label='signals_table'
                    style={{ border: "1px solid #bdbdbd" }}
                  >
                    <TableHead style={{ backgroundColor: "white" }}>
                      <TableRow>
                        <TableCell className={classes.signalTableHead}>
                          Name
                        </TableCell>
                        <TableCell className={classes.signalTableHead}>
                          Machine Type
                        </TableCell>
                        <TableCell className={classes.signalTableHead}>
                          HMI Type
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    {rule.signals.map((signal) => {
                      return (
                        <TableRow key={`signal-${signal.id}`}>
                          <TableCell className={classes.signalcell}>
                            {signal.name}
                          </TableCell>
                          <TableCell className={classes.signalcell}>
                            {signal.machine_type}
                          </TableCell>
                          <TableCell className={classes.signalcell}>
                            {signal.hmi_type}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </Table>
                </Grid>
              </Grid>
            </Box>
          </Collapse>
        </TableCell>
        <TableCell>{rule.maximum_scope_depth}</TableCell>
        <TableCell>
          {anomalyRuleComponent ? (
            <Grid>
              <DeleteOutlineIcon
                className={classes.binIcon}
                onClick={() => handleDelete(rule, selectedEntities)}
              />
              <Button
                color='primary'
                onClick={() => {
                  handleUpdate(rule, selectedEntities);
                }}
              >
                Confirm
              </Button>
            </Grid>
          ) : (
            <Button
              color='primary'
              onClick={() => {
                handleUpdate(rule);
                handleCloseDialog(selectedEntities);
              }}
            >
              +Add
            </Button>
          )}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell
          style={{ paddingBottom: 0, paddingTop: 0 }}
          colSpan={6}
        ></TableCell>
      </TableRow>
    </React.Fragment>
  );
};

export const AnomalySignalsComponent = ({ props , handleCreateAnomalyDialog }) => {
  const {
    open,
    handleCloseDialog,
    scroll,
    handleUpdate,
    anomalyRuleComponent,
    handleDelete,
    moduleFrom
  } = props;

  const classes = useStyles();
  const descriptionElementRef = React.useRef(null);
  const [signals, setSignals] = useState({
    options: [],
    getOptionLabel: (option) => "",
  });
  const [anomalyTypeList, setAnomalyTypeList] = useState({
    options: [],
    getOptionLabel: (option) => "",
  });
  const [anomalyRules, setAnomalyRules] = useState([]);
  const [value, setValue] = useState(null);
  const [anomalyType, setAnomalyType] = useState(null);
  const [anomalyTypeId, setAnomalyTypeId] = useState("");
  const anomalyConfigurationResponse = useSelector(
    (state) => state.anomalyRule
  );
  const [selectedSignals, setSelectedSignals] = useState([]);
  const [selectedAnomalyTypes, setSelectedAnomalyTypes] = useState([]);
  const rulesPerPage = 8;
  const [page, setPage] = useState(1);
  const [currentPage, setcurrentPage] = useState(1);
  const [currentFiltered, setCurrentFiltered] = useState("");
  const [searchResultButtonStatus, setSearchResultButtonStatus] = useState(false);
  const [selectedIds, setSelectedIds] = useState({
    anomalyTypeIds: "",
    signalIds: "",
  });
  const [hmi, setHMI] = useState([]);
  const [selectedHMI, setSelectedHMI] = useState("");
  const [selectedNode, setSelectedNode] = useState("");
  const [selectedFunction, setSelectedFunction] = useState("");
  const [getParams, setGetParams] = useState("");
  const [signalsLoading, setSignalsLoading] = useState("");
  const queryValues = queryString.parse(history.location.search);
  const {machine_type, hmi_type} = queryValues;

  const machineTypes = useSelector(
    (state) => state.selectMenuData.selectMachineTypes
  );
  const scopedAnomalyRuleResponse = useSelector(
    (state) => state.scopedAnomalyRule
  );
  const anomalyRuleFilter = useSelector(
    (state) => state.detailsPersist.anomalyRuleFilter
  );
  const anomalyRuleLoading = useSelector((state) => state.anomalyRule.loading);
  const typeFilters = useSelector((state) => state.anomalyRule.typeFilters);
  const deletedAnomalyID = useSelector((state) => state.anomalyRule.deletedAnomalyRule);
  const [cancelToken, setCancelToken] = useState(null);
  const dispatch = useDispatch();

  const getAnomalyRule = (ruleRequestBody) => {
    if (ruleRequestBody.anomaly_type_ids || ruleRequestBody.signal_ids) {
      ruleRequestBody = { ...ruleRequestBody, with_signals: true };
      dispatch(fetchAnomalyRule(ruleRequestBody,machine_type,hmi_type));
    } else {
      setAnomalyRules([]);
    }
  };

  useEffect(()=>{
    dispatch(
      fetchAnomalyNode({
        machine_type: machine_type,
        hmi_type: hmi_type,
      })
    );
  },[])

  useEffect(() => {
    if (typeFilters) {
      if (typeFilters.machine) {
        dispatch(fetchAnomalyHMI({ machine_type: machine_type}));
      }
      if (typeFilters.hmi) {
        setSelectedHMI(typeFilters.hmi);
        dispatch(
          fetchAnomalyNode({
            machine_type: typeFilters.machine,
            hmi_type: typeFilters.hmi,
          })
        );
      }
      if (typeFilters.node) {
        setSelectedNode(typeFilters.node);
        dispatch(
          fetchAnomalyFunction({
            machine_type: machine_type,
            hmi_type: hmi_type,
            node_number: typeFilters.node.number,
          })
        );
      }
      if (typeFilters.func) {
        setSelectedFunction(typeFilters.func);
      }
      if(typeFilters.type){
        setAnomalyType(typeFilters.type)
      }
      const {machine,hmi,node,func,type}=typeFilters
      getSignals(machine,hmi,node,func,type)
    }
  }, []);

  useEffect(() => {
    if (anomalyRuleFilter) {
      setSelectedSignals(anomalyRuleFilter.selectedSignals);
      setSelectedAnomalyTypes(anomalyRuleFilter.selectedAnomalyTypes);
    }
  }, [anomalyRuleFilter]);
  
  useEffect(() => {
    if(selectedSignals.length> 0){
      var anomalyTypeIds = selectedAnomalyTypes.map((type) => {
        return type.id;
      });
      var signalIds = selectedSignals.map((signal) => {
        return signal.id;
      });
      getAnomalyRule({
        anomaly_type_ids: anomalyTypeIds.toString(),
        signal_ids: signalIds.toString(),
      });
      setSelectedIds({
        anomalyTypeIds: anomalyTypeIds.toString(),
        signalIds: signalIds.toString(),
      });
    }
  if(!selectedSignals.length >0){
    setCurrentFiltered("")
    setSelectedIds({
      anomalyTypeIds: "",
      signalIds: "",
    });
  }
  }, [selectedSignals]);

  useEffect(() => {
    if (anomalyConfigurationResponse.signals) {
      const defaultProps = {
        options: anomalyConfigurationResponse.signals,
        getOptionLabel: (option) => (option.name ? option.name : ""),
      };
      setSignals(defaultProps);
    }
  }, [anomalyConfigurationResponse.signals]);

  useEffect(() => {
    if (anomalyConfigurationResponse.anomalyType) {
      const defaultProps = {
        options: anomalyConfigurationResponse.anomalyType,
        getOptionLabel: (option) => (option.id ? option.id : ""),
      };
      setAnomalyTypeList(defaultProps);
    }
  }, [anomalyConfigurationResponse.anomalyType]);

  useEffect(() => {
    if (anomalyConfigurationResponse.anomalyRule) {
      setAnomalyRules(anomalyConfigurationResponse.anomalyRule);
      setPage(1);
      setcurrentPage(1);
    }
  }, [anomalyConfigurationResponse.anomalyRule]);

  useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);

  useEffect(() => {
    if (anomalyRules) {
      const indexOfLastRule = currentPage * rulesPerPage;
      const indexOfFirstRule = indexOfLastRule - rulesPerPage;
      setCurrentFiltered(anomalyRules.slice(indexOfFirstRule, indexOfLastRule));
    }
  }, [anomalyRules, currentPage]);

  useEffect(() => {
    if (deletedAnomalyID && currentFiltered && currentFiltered.length > 0) {
      var deletedRule = currentFiltered.filter(
        (item) => item.id !== deletedAnomalyID
      );
      setCurrentFiltered(deletedRule);
    }
  }, [deletedAnomalyID]);

  useEffect(() => {
    setHMI(scopedAnomalyRuleResponse.hmi);
  }, [scopedAnomalyRuleResponse.hmi]);

  const getSignals = (machine, hmi, node, func, type) => {
    if (machine && hmi) {
      const params = {
        machine_type: machine_type,
        ...(node ? { node_number: node.number } : {}),
        ...(func ? { function_number: func.number } : {}),
        ...(type?{anomaly_type:type}:{}),
        with_anomaly_rule: moduleFrom === "scoped_finding_rule_configuration"? true :false,
      };
      if (cancelToken !== null) {
        cancelToken.cancel("Operation canceled due to new request.");
      }
      let c = axios.CancelToken.source();
      setCancelToken(c);
      setGetParams(params)
      dispatch(setTypeFilters({ machine, hmi, node, func, type }));
    }
  };

  const handleGetSignals = () => {
    setSearchResultButtonStatus(true)
    setSignals("")
    setCurrentFiltered("")
    setSelectedSignals([])
    setSignalsLoading(true)
    const params = {
      machine_type: machine_type,
      hmi_type:hmi_type,
      ...(selectedNode ? { node_number: selectedNode.number } : {}),
      ...(selectedFunction ? { function_number: selectedFunction.number } : {}),
      ...(anomalyType?{anomaly_type:anomalyType.id}:{}),
      with_anomaly_rule: moduleFrom === "scoped_finding_rule_configuration"? true :false,
    };
    dispatch(fetchSignals(params, cancelToken));
  }

  useEffect(() => {
   if(signals){
    setSignalsLoading(false)
   }
  }, [signals]);

  const paginate = (pageNumber) => {
    setcurrentPage(pageNumber);
  };

  const handleChange = (event, value) => {
    setPage(value);
    paginate(value);
  };

  const handleDeleteSignal = (index) => {
    const arr = [...selectedSignals];
    arr.splice(index, 1);
    let entities = {
      selectedSignals: [...arr],
      selectedAnomalyTypes: selectedAnomalyTypes,
    };
    dispatch(persistAnomalyRuleFilter(entities));
  };

  const handleNodeChange = async (newValue) => {
    setSelectedNode(newValue);
    setSelectedFunction("");
    if (newValue) {
      await dispatch(
        fetchAnomalyFunction({
          machine_type: machine_type,
          hmi_type: hmi_type,
          node_number: newValue.number,
        })
      );
      getSignals(machine_type, hmi_type, newValue, selectedFunction, anomalyType);
    }
    else{
        setSelectedNode("");  
        setSignals("")
        setCurrentFiltered("")
        setSelectedSignals([])
        setSelectedIds({
          anomalyTypeIds: "",
          signalIds: "",
        });
        setSearchResultButtonStatus(false)
    }
  };

  const handleFunctionChange = (newValue) => {
    if (newValue){
      setSelectedFunction(newValue);  
    }else {
      setSelectedFunction("");  
      setSignals("")
      setCurrentFiltered("")
      setSelectedSignals([])
      setSelectedIds({
        anomalyTypeIds: "",
        signalIds: "",
      });
      setSearchResultButtonStatus(false)
  }
  getSignals(machine_type, hmi_type, selectedNode, newValue? newValue: null, anomalyType);
  };

  const handleSignalChange = (newValue) => {
    if(newValue){
    if (!selectedIds.signalIds.includes(newValue.id)) {
      setValue(newValue.name);
      setSelectedSignals([...selectedSignals, newValue]);
      if (anomalyRuleComponent) {
        let entities = {
          selectedSignals: [...selectedSignals, newValue],
          selectedAnomalyTypes: selectedAnomalyTypes,
        };
        dispatch(persistAnomalyRuleFilter(entities));
      }
    }
    }
  };
  
  const handleAnomalyTypeChange = (newValue) => {
    if(newValue){
    setAnomalyType(newValue);
    setAnomalyTypeId(newValue.id);
    setSelectedAnomalyTypes([...selectedAnomalyTypes, newValue]);
    }
    else{
      setAnomalyType(""); 
      setAnomalyTypeId("") 
      setSelectedAnomalyTypes([]);
      setSignals("")
      setCurrentFiltered("")
      setSelectedSignals([])
      setSearchResultButtonStatus(false)
    }
    getSignals(machine_type, hmi_type, selectedNode,selectedFunction, newValue? newValue:null );
  };

  useEffect (()=>{
      setSignals("")
      setCurrentFiltered("")
      setSelectedSignals([])
  },[moduleFrom])

  const AnomalyTable = () => {
    return (
      <>
      <TableContainer component={Paper}>
        {selectedSignals.length>0 && currentFiltered.length > 0 &&
        <Table aria-label='collapsible table'>
          <TableHead>
            <TableRow>
              <TableCell />
              <TableCell className={classes.tableHead}>Rule ID</TableCell>
              <TableCell className={classes.tableHead}>Anomaly Type</TableCell>
              <TableCell className={classes.tableHead}>
                Maximum Scope Depth
              </TableCell>
              <TableCell />
            </TableRow>
          </TableHead>
          <TableBody>
            {(anomalyConfigurationResponse.loading || anomalyRuleLoading) && (
              <SkeletonTableList count={4} />
            )}
            {currentFiltered &&
            currentFiltered.length > 0 &&
            !anomalyConfigurationResponse.loading && (
              currentFiltered.map((rule) => (
                <Row
                  key={rule.id}
                  rule={rule}
                  handleCloseDialog={handleCloseDialog}
                  handleUpdate={handleUpdate}
                  anomalyRuleComponent={anomalyRuleComponent}
                  handleDelete={handleDelete}
                  selectedEntities={{
                    selectedSignals: [...selectedSignals],
                    selectedAnomalyTypes: [...selectedAnomalyTypes],
                  }}
                />
              ))
            )}
          </TableBody>
        </Table>      
        } 
      </TableContainer>
      {currentFiltered.length === 0 && 
        <Grid container direction="row" justifyContent="center" alignItems="center">
          <Grid item className={classes.label}>No data found!</Grid>
        </Grid>
      }
      </>
    );
  };

  return (
    <>
      <DialogTitle>
        <Grid container spacing={3}>
          <Grid item container direction='row' spacing={2} className="searchContainer">
            <Grid item className={classes.alignBottom} xs={2}>
              {machine_type ? (
                <Autocomplete
                  className={classes.signalsInput}
                  options={machineTypes ? machineTypes : []}
                  value={machine_type}
                  disabled
                  renderInput={(params) => (
                    <TextField
                    required = {true}
                      className={classes.requiredField}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment>
                            <IconButton>
                              <SearchIcon color='disabled' />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      {...params}
                      label='Machine Type'
                    />
                  )}
                />
              ) : (
                <div className={classes.signalsInput}>
                  <SkeletonPaper row={1} />
                </div>
              )}
            </Grid>
            <Grid item className={classes.alignBottom} xs={2}>
              {machine_type ? (
                <Autocomplete
                  className={classes.signalsInput}
                  disabled                
                  options={hmi ? hmi : []}
                  value={hmi_type}
                  renderInput={(params) => (
                    <TextField
                    required = {true}
                      className={classes.requiredField}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment>
                            <IconButton>
                              <SearchIcon color='disabled' />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      {...params}
                      label='HMI Version'
                    />
                  )}
                />
              ) : (
                <div className={classes.signalsInput}>
                  <SkeletonPaper row={1} />
                </div>
              )}
            </Grid>
            <Grid item className={classes.alignBottom} xs={2}>
              {machine_type && scopedAnomalyRuleResponse.node ? (
                <Autocomplete
                  className={classes.signalsInput}
                  value={selectedNode}
                  options={
                    scopedAnomalyRuleResponse.node
                      ? scopedAnomalyRuleResponse.node
                      : []
                  }
                  getOptionLabel={(option) => (option.name ? option.name : "")}
                  onChange={(event, newValue) => handleNodeChange(newValue)}
                  renderInput={(params) => (
                    <TextField
                    required = {true}
                      className={classes.requiredField}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment>
                            <IconButton>
                              <SearchIcon color='disabled' />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      {...params}
                      label='Modul'
                    />
                  )}
                />
              ) : (
                <div className={classes.signalsInput}>
                  <SkeletonPaper row={1} />
                </div>
              )}
            </Grid>
            <Grid item className={classes.alignBottom} xs={2}>
              {machine_type && scopedAnomalyRuleResponse.function ? (
                <Autocomplete
                  className={classes.searchFGroupStyle}
                  disabled={
                    selectedNode &&
                    scopedAnomalyRuleResponse.function.length > 0 
                      ? null
                      : true
                  }
                  value={selectedFunction}
                  options={
                    scopedAnomalyRuleResponse.function
                      ? scopedAnomalyRuleResponse.function
                      : []
                  }
                  getOptionLabel={(option) => (option.name ? option.name : "")}
                  onChange={(event, newValue) => {
                    handleFunctionChange(newValue);
                  }}
                  renderInput={(params) => (
                    <TextField
                      InputProps={{
                        endAdornment: (
                          <InputAdornment>
                            <IconButton>
                              <SearchIcon color='disabled' />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      {...params}
                      label='Function Group'
                    />
                  )}
                />
              ) : (
                <div className={classes.searchFGroupStyle}>
                  <SkeletonPaper row={1} />{" "}
                </div>
              )}
            </Grid>
            <Grid item className={classes.alignBottom} xs={2}>
            {anomalyTypeList ? (
              <Autocomplete
                className={classes.anomalyInput}
                {...anomalyTypeList}
                value={anomalyType}
                onChange={(event, newValue) => {
                  handleAnomalyTypeChange(newValue);
                }}
                renderInput={(params) => (
                  <TextField
                    InputProps={{
                      endAdornment: (
                        <InputAdornment>
                          <IconButton>
                            <SearchIcon color='disabled' />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                    {...params}
                    label='Anomaly Type'
                  />
                )}
              />
            ) : (
              <div className={classes.anomalyInput}>
                <SkeletonPaper row={1} />{" "}
              </div>
            )}
          </Grid>
          <Grid
            item
            xs={2}
            style={{display: "flex", alignItems: "center"}}
          >
            <Button  className ={classes.searchButton} disabled ={queryValues.machine_type && queryValues.hmi_type && selectedNode ?  false : true}  onClick={() => handleGetSignals()}  variant="contained" startIcon={<SearchIcon />}>Search</Button>
          </Grid>
          </Grid>
          <Grid item container direction='row' spacing={2}>
          <Grid item className={classes.alignBottom} xs={12}>
              {(signals && signals.options.length > 0) ? (
                <Autocomplete
                  className={classes.signalsSearchStyle}
                  {...signals}
                  blurOnSelect
                  clearOnBlur
                  value={value}
                  onChange={(event, newValue) => {
                    handleSignalChange(newValue);
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label='Search Signal' />
                  )}
                />
              ) :signalsLoading?<div className={classes.anomalyInput}>
              <SkeletonPaper row={1} />{" "}
            </div>:
            searchResultButtonStatus?
              (
                <>
                <Typography variant='body2' className={classes.label} style={{textAlign: "center"}}>
                No Data Found 
                </Typography>
                <div style={{display:"flex"}}>
                  <Button style={{margin:'auto'}} onClick={() => handleCreateAnomalyDialog(true)}>+ Create New Anomaly Rule</Button>
                </div>
                </>
              )
              : null }
            </Grid>
            </Grid>
            {selectedSignals.length >0&&
          <Grid item container direction='row'>
            <Grid item>
              <Typography variant='body2' className={classes.label}>
                Signals Added:
              </Typography>
            </Grid>
            <Grid item xs={10} container>
              {selectedSignals.map((signal, index) => {
                return (
                  <Chip
                    key={`selectedSignal${signal.id}`}
                    className={classes.chip}
                    variant='outlined'
                    size='small'
                    label={signal.name}
                    onDelete={() => handleDeleteSignal(index)}
                  />
                );
              })}
            </Grid>
          </Grid>
          }
        </Grid>
      </DialogTitle>
      {!anomalyConfigurationResponse.error && currentFiltered && (
      <DialogContent
        style={{ overflowY: anomalyRuleComponent ? "hidden" : "auto" }}
      >
        <AnomalyTable />
        <FooterPagination
          page={page}
          handleChange={handleChange}
          rulesPerPage={rulesPerPage}
          totalRules={anomalyRules.length}
        />
      </DialogContent>
      )}
    </>
  );
};

export const SignalsDialog = React.memo((props) => {
  const classes = useStyles();
  const [openAnomalyCreation,setOpenAnomalyCreation] = useState(false)
  
  const handleCreateAnomalyDialog = () =>{
    setOpenAnomalyCreation(true);
  }

  const handleCloseDialog = () =>{
    setOpenAnomalyCreation(false);
  }

  return (
    <Dialog 
      open={props.open} 
      scroll={props.scroll} 
      className='paper' 
      PaperProps={{style: {overflow:"hidden", position:'fixed', right:'0', height:'100%'},
    }}> 
      <Grid container direction="row" style={{height:'100%'}}>
          <Grid item style={{backgroundColor:"#262523",height:'100%',width:'5%'}}>
              <div className={classes.aligningDiv}>
              <CancelRoundedIcon 
                className={classes.cancelIconStyle}
                onClick={() =>
                props.handleCloseDialog()
              } 
              /></div>
          </Grid>
          <Grid item container xs={11} md={11} direction="column" style={{padding:'15px'}}> 
            {!props.anomalyRuleComponent && (
                <Grid item>
                  <Typography className='text-secondary' variant='h5'>
                    Select Anomaly Rule
                  </Typography>
                </Grid>
            )}
            {!props.anomalyRuleComponent && (
              <Grid item style={{marginTop:'10px'}}>
                <Typography variant='body2' className={classes.label}>
                  Search for Signals
                </Typography>
                <AnomalySignalsComponent props={props} handleCreateAnomalyDialog={handleCreateAnomalyDialog}/>
              </Grid>
            )}
          </Grid>
          <CreateAnomalyRule
            open={openAnomalyCreation}
            handleCloseDialog={handleCloseDialog}
            scroll={"paper"}
            initiateFunctionCall={false}
          />
      </Grid>   
    </Dialog>
  );
})

export default React.memo (SignalsDialog)
